import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { TreeNode } from 'primeng/api';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { DialogService } from 'primeng/dynamicdialog';
import { PetitionBuilderService } from '../../../../services/petition-builder.service';
import { map } from 'rxjs/internal/operators/map';
import { NgForm } from '@angular/forms';
import { AppServicesLibraryService } from 'app-services-library';
import { PrimaryData } from 'app-models';

@Component({
  selector: 'i140-organize-documents',
  templateUrl: './organize-documents.component.html',
  styleUrls: ['./organize-documents.component.scss']
})
export class OrganizeDocumentsComponent implements OnInit, AfterViewInit {

  @ViewChild('organizeDocumentsForm', { static: true }) organizeDocumentsForm: NgForm;
  supportingDocuments;
  supportingDocumentsTree: TreeNode[];
  @ViewChild('inplace', { static: false }) inplaceEditor;
  @ViewChild('inplaceCustom', { static: false }) inplaceEditorCustom;
  newNode = [];
  titleSheetButtonEnabled: boolean = true;
  SubTaskOverView;
  newTitleSheetSequenceNo;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  primaryData: PrimaryData;

  observableSubscription$ = new Subject();
  guardSubscription: any;

  constructor(
    private toastr: ToastrService,
    private store: Store<any>,
    private pbService: PetitionBuilderService,
    private dynamicDialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
  }

  ngOnInit() {
    this.primaryData = this.dynamicDialogConfig.data;
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      // this.getOrgranizedDocument();
      this.stepDetails = data;
      this.toggleControlsStatus();
    });
  }

  ngAfterViewInit(){
    // this.organizeDocumentsForm.form.valueChanges.pipe(
    //   map(() => this.organizeDocumentsForm.dirty),
    // ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
    //   if (dirty) {
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   } else {
    //     this.store.dispatch(new MarkCleanFormAction({
    //       dirty: false
    //     }));
    //   }
    // });
  }

  // onDrop(event) {
  //   this.store.dispatch(new MarkDirtyFormAction({
  //     dirty: true
  //   }));
  //   if (event.dropNode.class == 'custom') {
  //     event.dragNode.data["class"] = "customChild";
  //   }
  //   else {
  //     event.dragNode.data["class"] = "";
  //   }
  //   if (event.originalEvent.currentTarget.className === 'p-treenode-droppoint ng-star-inserted p-treenode-droppoint-active') {
  //     if (event.dragNode.type == "child" && event.dropNode.type == "parent")
  //       event.reject();
  //     else
  //       event.accept();
  //   }
  //   else {
  //     if (event.originalEvent.currentTarget.className === "p-treenode-content p-treenode-dragover") {
  //       if (event.dragNode.type == event.dropNode.type) {

  //       }
  //       else
  //         event.accept();
  //     }
  //     else
  //       event.accept();
  //   }
  // }

  // renameCustomTitleSheet(event) {
  //   this.toastr.success("Title Sheet Renamed", 'Success');
  //   //this.inplaceEditor.onDeactivate.emit(event);
  //   this.inplaceEditorCustom.deactivate(event);
  // }

  // postOrganizedDocument() {
  //   let organizedList = [];
  //   this.supportingDocumentsTree.forEach((element, index: number) => {
  //     let obj = {
  //       "titleSheetName": element != "custom" ? element["data"]["titleSheetName"] : element["data"]["categoryName"],
  //       "titleSheetSequnceNo": index,
  //       "titleSheetId": element["data"]["titleSheetId"],
  //       "documentTypes": []
  //     }
  //     if (element["children"] != undefined) {
  //       element["children"].forEach((doc, subIndex: number) => {
  //         let child = {
  //           'docName': doc["data"]["docName"],
  //           "fileCategory": doc["data"]["fileCategory"],
  //           "titleSheetDetailSequenceNo": subIndex + index,
  //           "titleSheetDetailId": doc["data"]["titleSheetDetailId"],
  //           'documents': doc["data"]["documents"]
  //         };
  //         obj["documentTypes"].push(child);
  //       });
  //     }
  //     organizedList.push(obj);
  //   });
  //   this.pbService.postOrganizedDocument(this.dynamicDialogConfig.data.superTaskId,
  //     this.dynamicDialogConfig.data.i140CaseId, organizedList).subscribe((response: any) => {
  //       if (response) {
  //         this.toastr.success(response.message, 'Success');
  //         this.titleSheetButtonEnabled = true;
  //         this.store.dispatch(new MarkCleanFormAction({
  //           dirty: false
  //         }));
  //       }
  //     });
  // }

  // viewDocument(item) {
  //   const docPath = item.substring(23);
  //   window.open(`${environment.docs}${docPath}`, "_blank");
  // }

  // deleteDocument(item) {
  //   // this.rfeService.deleteRFEDocument(this.SubTaskOverView['id'], item).subscribe((response: any) => {
  //   //   if (response) {
  //   //     this.toastr.success(response.message);
  //   //     this.getOrgranizedDocument();
  //   //   }
  //   // });
  //   // const deleteDialogRef = this.dialogService.open(DeleteDialogComponent, DeleteDialogConfigurations);
  //   // deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
  //   //   if (response) {
  //   //     this.pbService.deleteOrganizedDocuments(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, subexperiencelist.id, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
  //   //       this.toastr.success(response.message);
  //   //       this.getOrgranizedDocument();
  //   //     })
  //   //   }
  //   // });
  // }

  // getOrgranizedDocument() {
  //   let tempData = [];
  //   this.pbService.getOrganizeDocuments(this.dynamicDialogConfig.data.superTaskId,
  //     this.dynamicDialogConfig.data.i140CaseId).subscribe((response) => {
  //       this.newTitleSheetSequenceNo = response.data[response.data.length - 1]["titleSheetSequnceNo"] + 1;
  //       response.data.forEach((element) => {
  //         let obj = {
  //           data: element,
  //           type: 'parent',
  //           children: []
  //         };
  //         element.documentTypes.filter(x => x.present == true).forEach(doc => {
  //           obj.children.push({
  //             data: doc,
  //             type: 'child'
  //           });
  //         });
  //         if (obj.children && obj.children.length > 0) {
  //           tempData.push(obj);
  //         }
  //       });
  //       this.supportingDocumentsTree = <TreeNode[]>tempData;
  //       this.supportingDocumentsTree.forEach(node => {
  //         this.expandRecursive(node, true);
  //       });
  //     });
  // }

  // resetOrganizedDocument() {
  //   this.pbService.resetOrganizeDocuments(this.dynamicDialogConfig.data.superTaskId,
  //     this.dynamicDialogConfig.data.i140CaseId).subscribe((response) => {
  //       if (response) {
  //         this.toastr.success(response.message, 'Success');
  //         this.getOrgranizedDocument();
  //       }
  //     });
  // }

  // private expandRecursive(node: TreeNode, isExpand: boolean) {
  //   node.expanded = isExpand;
  //   if (node.children) {
  //     node.children.forEach(childNode => {
  //       this.expandRecursive(childNode, isExpand);
  //     });
  //   }
  // }

  // //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
